import Image from 'next/image';
import { Button, ButtonClose, ButtonThemes, MyLink } from '@app/shared';
import { getPriceFormat } from '@shared/helpers';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { IconArrowLeft } from '@koleso-icons';
import ModalStoryImage from '../images/modal-story.png';

import styles from './ModalStory.module.scss';

export const ModalStory = ({ minPriceShow, handleClose }) => {
  const isMobile = useWindowSizing(990);

  if (isMobile) {
    return (
      <div className={styles.MobileWrapper}>
        <div className={styles.MobileContent}>
          <div className={styles.HeaderModal}>
            <Button themes={ButtonThemes.Clear} className={styles.BtnBack} onClick={handleClose}>
              <IconArrowLeft />
              Назад
            </Button>
            <ButtonClose className={styles.BtnClose} onClick={handleClose} />
          </div>
          <div className={styles.Container}>
            <div className={styles.Title}>
              Покупка
              <br />и установка
              <br />
              по вашим правилам!
            </div>
            <div className={styles.InfoBlock}>
              <ul>
                <li>
                  Совершите покупку
                  <br />
                  от {getPriceFormat(minPriceShow)} ₽
                </li>
                <li>
                  Получите доступ к <div>дополнительным слотам</div> для записи на монтаж
                </li>
              </ul>
              <div className={styles.ImageDate} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.Wrapper}>
      <div className={styles.HeaderModal}>
        <div className={styles.Title}>Как это работает</div>
        <ButtonClose onClick={handleClose} />
      </div>
      <div className={styles.Content}>
        <ol>
          <li>Совершите покупку на сумму от {getPriceFormat(minPriceShow)} ₽.</li>
          <li>Получите доступ к дополнительным слотам для записи на монтаж.</li>
          <li>
            Выберите удобное время и <MyLink href={'/rec/?widgetOpened'}>запишитесь на шиномонтаж.</MyLink>
          </li>
          <li>Переобуйтесь в короткий срок без ожидания.</li>
        </ol>
        <Image src={ModalStoryImage.src} width={540} height={240} alt={'Описание'} layout={'responsive'} priority />
      </div>
    </div>
  );
};
